
import type { AppRouteObject } from "../routes";
import { ApprovalRoute } from "./routes/ApprovalRoute";

const routes: AppRouteObject[] = [
  ApprovalRoute,
];

export default routes;